<main class="container-geral">
  <section class="cabecalho">
    <div class="d-flex">
      <h1 class="titulo fonte-DM-Sans">
        {{ 'COMPONENTS.TURNOS_LIST.title' | transloco }}
      </h1>
    </div>

    @if (permissoes.criar) {
      <button class="btn-cadastrar-listagem fonte-DM-Sans" routerLink="cadastro">
        {{ 'COMPONENTS.TURNOS_LIST.createButton' | transloco }}
      </button>
    }
  </section>

  <section>
    <div class="d-flex flex-row-reverse gap-4 mb-2 mt-3">
      <div class="container-filtro">
        <object class="icone-lupa" data="assets/icones-filtros/icone-lupa.svg" type="image/svg+xml"></object>
        <input (keyup)="aplicarFiltro($event)" class="filtro-pesquisa color-input" placeholder="{{ 'COMPONENTS.TURNOS_LIST.searchPlaceholder' | transloco }}"/>
      </div>

      <app-filtro-clientes (carregarCliente)="buscarTurnos($event)"></app-filtro-clientes>
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-none">
      <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length" class="turno-vazio text-center text-muted" [hidden]="loading">
          {{ 'COMPONENTS.TURNOS_LIST.empty' | transloco }}
        </td>
      </tr>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPONENTS.TURNOS_LIST.columns.name' | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" [hidden]="loading">
          {{ element.vc_nome }}
        </td>
      </ng-container>

      <ng-container matColumnDef="horario_inicio">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPONENTS.TURNOS_LIST.columns.startTime' | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" [hidden]="loading">
          {{ element.tm_hora_inicio | converterBRT }}
        </td>
      </ng-container>

      <ng-container matColumnDef="horario_fim">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPONENTS.TURNOS_LIST.columns.endTime' | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" [hidden]="loading">
          {{ element.tm_hora_fim | converterBRT }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPONENTS.TURNOS_LIST.columns.status' | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" [hidden]="loading">
          <span class="etiqueta {{ element.bl_ativo ? 'etiqueta-ativa' : 'etiqueta-desativada' }}">
            {{ element.bl_ativo
                ? ('COMPONENTS.TURNOS_LIST.status.active' | transloco)
                : ('COMPONENTS.TURNOS_LIST.status.inactive' | transloco)
            }}
          </span>
        </td>
      </ng-container>

      @if (permissoes.exibirAcoes) {
        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="col-acoes">
            {{ 'COMPONENTS.TURNOS_LIST.columns.actions' | transloco }}
          </th>

          <td mat-cell *matCellDef="let element" [hidden]="loading">
            <div id="listaBotoes" class="td-botoes d-flex justify-content-center">
              @if (permissoes.editar) {
                <button (click)="alterarEstadoTurno(element)" class="botaoAcao" matTooltip="{{
                    element.bl_ativo
                      ? ('COMPONENTS.TURNOS_LIST.tooltips.deactivate' | transloco)
                      : ('COMPONENTS.TURNOS_LIST.tooltips.activate' | transloco)
                  }}" matTooltipPosition="above"
                >
                
                <img
                  [src]="'assets/compartilhados/' + (element.bl_ativo ? 'relogio-off.svg' : 'relogio-on.svg')"
                  alt="Alterar Status"
                />

                </button>

                <button class="botaoAcao" routerLink="editar/{{ element.sr_id }}" matTooltip="{{ 'COMPONENTS.TURNOS_LIST.tooltips.edit' | transloco }}" matTooltipPosition="above">
                  <img src="assets/compartilhados/caneta.svg" alt="Editar" />
                </button>
              }

              @if (permissoes.excluir) {
                <button class="botaoAcao" (click)="excluir(element.sr_id)" matTooltip="{{ 'COMPONENTS.TURNOS_LIST.tooltips.delete' | transloco }}" matTooltipPosition="above">
                  <img src="assets/compartilhados/lixeira.svg" alt="Excluir" />
                </button>
              }
            </div>
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    @if (loading) {
      <app-loading [linhas]="5" [colunas]="1" [tipo]="'listagem'"></app-loading>
    }
  </section>
</main>
